import { Component, ElementRef, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdditionalDetailsComponent } from './additional-details/additional-details.component';
import { EmergencyContactsComponent } from './emergency-contacts/emergency-contacts.component';
import { SignupFormComponent } from './signup-form/signup-form.component';
import { NextOfKinComponent } from './next-of-kin/next-of-kin.component';
import { PaymentMethodComponent } from './payment-method/payment-method.component';
import { FirstPaymentComponent, FirstPaymentContent } from './first-payment/first-payment.component';
import { SlideCommonService } from '@app/application/common/slide-common.service';

@Component({
    selector: 'app-signup',
    imports: [
        CommonModule,
        SignupFormComponent,
        AdditionalDetailsComponent,
        EmergencyContactsComponent,
        NextOfKinComponent,
        PaymentMethodComponent,
        FirstPaymentComponent
    ],
    templateUrl: './signup.component.html',
    styleUrl: './signup.component.scss'
})
export class SignupComponent implements OnInit {

    pageHeading: string = "Signup - Additional Details";
    firstPaymentContent: FirstPaymentContent | any = {};

    constructor(private slideCommonService: SlideCommonService, private el: ElementRef) {
    }

    ngOnInit(): void {
        console.log("Signup component has loaded!");

        this.slideCommonService.setRef(this.el);

        const cpt = this.el.nativeElement;
        this.firstPaymentContent.paySecurelyButtonText = cpt.getAttribute("paySecurelyButtonText");
        this.firstPaymentContent.continuePaymentButtonText = cpt.getAttribute("continuePaymentButtonText");
        this.firstPaymentContent.enterAmountHeading = cpt.getAttribute("enterAmountHeading");
        this.firstPaymentContent.enterAmountSubHeading = cpt.getAttribute("enterAmountSubHeading");
        this.firstPaymentContent.enterAmountBody = cpt.getAttribute("enterAmountBody");
        this.firstPaymentContent.cardDetailsHeading = cpt.getAttribute("cardDetailsHeading");
        this.firstPaymentContent.cardDetailsSubHeading = cpt.getAttribute("cardDetailsSubHeading");
        this.firstPaymentContent.cardDetailsBody = cpt.getAttribute("cardDetailsBody");
        this.firstPaymentContent.failedPaymentMessage = cpt.getAttribute("failedPaymentMessage");
        this.firstPaymentContent.errorPaymentMessage = cpt.getAttribute("errorPaymentMessage");
        this.firstPaymentContent.thankYouPageUrl = cpt.getAttribute("thankYouPageUrl");
        this.firstPaymentContent.processingPaymentTitle = cpt.getAttribute("processingPaymentTitle");
        this.firstPaymentContent.processingPaymentBody = cpt.getAttribute("processingPaymentBody");
        this.firstPaymentContent.paymentCardPageUrl = cpt.getAttribute("paymentCardPageUrl");

        Breakpoint.init();
    }
}
